import { Link, useLocation } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { SITE, PROPERTIES } from "@/data/site";

const Footer = () => {
  const location = useLocation();
  if (location.pathname === "/owner" || location.pathname.startsWith("/handout")) return null;

  return (
    <footer className="bg-[#0F2A52] text-[#FCFAF6] mt-24" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <h3 className="font-display text-3xl mb-4">PARADISIO RESORTS</h3>
          <p className="text-sm leading-relaxed text-[#FCFAF6]/70 max-w-sm">
            Four privately owned holiday homes on the Queensland coast, looked after and let directly
            by {SITE.owner}.
          </p>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.28em] text-[#FCFAF6]/50 mb-5">Our properties</p>
          <ul className="space-y-3">
            {PROPERTIES.map((p) => (
              <li key={p.slug}>
                <Link
                  to={`/stay/${p.slug}`}
                  className="text-sm text-[#FCFAF6]/85 hover:text-[#FCFAF6] transition-colors duration-200"
                  data-testid={`footer-link-${p.slug}`}
                >
                  {p.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs uppercase tracking-[0.28em] text-[#FCFAF6]/50 mb-5">Enquiries</p>
          <div className="space-y-4 text-sm">
            <a href={`tel:${SITE.phone}`} className="flex items-center gap-3" data-testid="footer-call-link">
              <Phone size={16} className="text-[#B08A3E]" /> {SITE.phoneDisplay}
            </a>
            <a href={`mailto:${SITE.email}`} className="flex items-center gap-3" data-testid="footer-email-link">
              <Mail size={16} className="text-[#B08A3E]" /> {SITE.email}
            </a>
            <p className="flex items-center gap-3 text-[#FCFAF6]/70">
              <MapPin size={16} className="text-[#B08A3E]" /> {SITE.region}
            </p>
          </div>
        </div>
      </div>
      <div className="border-t border-[#FCFAF6]/15">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-6 text-xs text-[#FCFAF6]/55 flex flex-col md:flex-row gap-2 md:justify-between">
          <span>© {new Date().getFullYear()} PARADISIO RESORTS · {SITE.domain}</span>
          <span>Booked directly with the owner · Queensland, Australia</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
